export default __webpack_public_path__ + "media/d8b605bd9689bf34a0351dffa9e6d467ab6ef84d756fc6364a0acfc015c0d059.svg";